import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Card } from '@blueprintjs/core';

import { getOrganizations } from 'actions/organization';

import Info from './info';
import Assign from './assign';

class Config extends Component {
  componentDidMount() {
    const { dispatch } = this.props;
    dispatch(getOrganizations());
  }

  renderAssign() {
    const {
      dispatch, organizations, nvr,
    } = this.props;
    return (
      <Assign
        dispatch={dispatch}
        id={nvr.id}
        organizations={organizations}
        name={nvr.name}
      />
    );
  }

  render() {
    const {
      nvr, dispatch, organizations, enableNameChange,
    } = this.props;
    const infoValues = {
      name: nvr.name,
      sr_num: nvr.serial,
      monitored: nvr.monitored ? 'true' : 'false',
    };
    return (
      <div className="columns">
        <div className="column is-one-third column-eq">
          <Card>
            <Info
              dispatch={dispatch}
              initialValues={infoValues}
              nvr={nvr}
              enableNameChange={enableNameChange}
            />
          </Card>
        </div>
        <div className="column is-two-third column-eq">
          <Card>
            <Assign
              nvr={nvr}
              dispatch={dispatch}
              organizations={organizations.data || []}
            />
          </Card>
        </div>
      </div>
    );
  }
}

Config.propTypes = {
  dispatch: PropTypes.func,
  organizations: PropTypes.object,
  nvr: PropTypes.object,
  enableNameChange: PropTypes.bool,
};

export default connect(state => ({
  organizations: state.organizations,
}))(Config);
